import { render, staticRenderFns } from "./StatusSemester.vue?vue&type=template&id=86687ec8&"
import script from "./StatusSemester.vue?vue&type=script&lang=js&"
export * from "./StatusSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports